<div class="flex h-full cursor-pointer border-primary border-dashed border-1" [ngStyle]="{'min-height': '20rem'}"
     (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)" [disabled]="disabled">
  <div class="flex m-auto">
    <div class="w-full">
      <div class="flex upload rounded-lg shadow-sm">
        <input hidden type="file" accept=".csv" multiple #fileInput (change)="uploadFile($event.target.files)"
               [disabled]="disabled">
        <div class="m-auto">
          <div class="icon w-full flex">
            <i class="pi pi-cloud-upload m-auto" style="color: var(--primary-color); font-size: 62px;"></i>
          </div>
          <div class="text-center mt-4">
            <p>{{'info.importCsv.dragAndDrop' | transloco}}</p>
            <div class="flex mb-3 text-center">
              <span class="w-full" style="border-bottom: 1px solid; line-height: 0.1em"></span>
              <span class="pl-2 pr-2" style="line-height: 0.2em">{{'info.importCsv.or' | transloco}}</span>
              <span class="w-full" style="border-bottom: 1px solid; line-height: 0.1em"></span>
            </div>
            <button pButton class="md:mr-2 p-button-primary my-2 md:mb-0">
              {{'info.importCsv.chooseFiles' | transloco}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

